export const onStateUpdatedEvent = ({ gridRef, onStateUpdated, params }) => {
  const {state} = params;
  const {sort} = state;

  // Need to include params in the argument
  // NOTE: onSelectionChanged(params)
  if (onStateUpdated) onStateUpdated(sort?.sortModel);
  
  gridRef.current.api.refreshCells({ force: true });
};